import React from "react";
import { Placement } from "@popperjs/core";
import cn from "classnames";

import { Popover } from "shared/common-ui/Popover";

import classes from "./Tooltip.module.scss";

type Offset = {
  top?: number;
  left?: number;
};

type TooltipType = {
  theme?: "dark";
  content: string | JSX.Element;
  children: string | JSX.Element;
  placement?: Placement;
  className?: string;
  arrow?: boolean;
  isOpen?: boolean;
  classNameTrigger?: string;
  appendTo?: "viewport" | "parent";
  offset?: Offset;
};

const Tooltip: React.FC<TooltipType> = ({
  theme = "dark",
  content,
  children,
  className,
  arrow = true,
  placement = "auto",
  isOpen,
  classNameTrigger,
  appendTo = "viewport",
  offset = {},
}): JSX.Element => {
  let event: "click" | "hover" | "custom" =
    typeof window !== "undefined" && "ontouchstart" in document.documentElement
      ? "click"
      : "hover";
  if (typeof isOpen !== "undefined") {
    event = "custom";
  }

  const mergedOffset: Offset = {
    top: 10,
    ...offset,
  };

  return (
    <div className={cn(classes.container, classNameTrigger)}>
      <Popover
        isOpenPopover={isOpen}
        placement={placement}
        offset={mergedOffset}
        event={event}
        appendTo={appendTo}
      >
        <Popover.Trigger>
          <div>{children}</div>
        </Popover.Trigger>
        <Popover.Content
          className={cn(classes.content, className, {
            [classes.themeDark]: theme === "dark",
          })}
        >
          <div>{content}</div>
          {arrow && <div data-popper-arrow className={classes.arrow} />}
        </Popover.Content>
      </Popover>
    </div>
  );
};

export default Tooltip;
